import { Bell, Boxes, Languages, Settings } from "lucide-react";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useParams } from "react-router";

const TABS = [
	{ key: "project", Icon: Boxes, label: "settings.project" },
	{ key: "config", Icon: Settings, label: "settings.config" },
	{ key: "ui-labels", Icon: Languages, label: "settings.uiLabels" },
	{ key: "notifications", Icon: Bell, label: "settings.notifications" },
] as const;

export function SettingsLayout() {
	const { slug } = useParams<{ slug: string }>();
	const { t } = useTranslation();

	return (
		<div className="flex flex-col h-full overflow-hidden">
			<div
				className="shrink-0 flex items-center gap-2 px-5 py-3"
				style={{
					borderBottom: "1px solid rgba(255,255,255,0.06)",
					background: "#111113",
				}}
			>
				{TABS.map(({ key, Icon, label }) => (
					<NavLink
						key={key}
						to={`/projects/${slug ?? ""}/settings/${key}`}
						className="group"
					>
						{({ isActive }) => (
							<div
								className="flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all duration-200"
								style={{
									background: isActive
										? "linear-gradient(135deg, #8b5cf6 0%, #3b82f6 100%)"
										: "transparent",
									color: isActive ? "#ffffff" : "#71717a",
									boxShadow: isActive
										? "0 0 20px rgba(139, 92, 246, 0.15)"
										: "none",
								}}
								onMouseEnter={(e) => {
									if (!isActive) {
										(e.currentTarget as HTMLDivElement).style.background =
											"rgba(255,255,255,0.03)";
										(e.currentTarget as HTMLDivElement).style.color = "#e4e4e7";
									}
								}}
								onMouseLeave={(e) => {
									if (!isActive) {
										(e.currentTarget as HTMLDivElement).style.background =
											"transparent";
										(e.currentTarget as HTMLDivElement).style.color = "#71717a";
									}
								}}
							>
								<Icon size={16} />
								{t(label)}
							</div>
						)}
					</NavLink>
				))}
			</div>

			<div className="flex-1 overflow-hidden">
				<Outlet />
			</div>
		</div>
	);
}
